module.exports = __webpack_public_path__ + "static/media/tool_logo_sonarQube.3af1625a.jpeg";